import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import './App.css';
import { Provider as AuthProvider } from './context/AuthContext';
import Landing from './routes/Landing';
import Account from './routes/Account';
import history from './history';
import UserVerified from './routes/UserVerified';
import TokenExpired from './routes/TokenExpired';
import ForgotPassword from './routes/ForgotPassword';
import WaitlistSignup from './routes/WaitlistSignup';
import UserAgreement from '../src/components/UserAgreement';
import Signup from './routes/Signup';

const App = () => {
  return (
    <AuthProvider>
      <Router history={history}>
        <Switch>
          <Route exact path='/' component={Landing} />
          <Route exact path='/forgot_password' component={ForgotPassword} />
          <Route exact path='/user_verified' component={UserVerified} />
          <Route exact path='/token_expired' component={TokenExpired} />
          <Route exact path='/waitlist_signup' component={WaitlistSignup} />
          <Route exact path='/user_agreement' component={UserAgreement} />
          <Route path='/dashboard' component={Account} />
          <Route path='/signup' component={Signup} />
        </Switch>
      </Router>
    </AuthProvider>
  );
};

export default App;
